<template>
  <div class="flex w-full">
    <div v-for="(label, key) in possibleClasses" :key="key" class="flex-1" @click="changeClass(key, label)">
      <div
        class="w-full text-gray-600 text-14 hover:bg-gray-100 rounded-8 cursor-pointer transition-colors duration-200"
        :class="[selectedClass[key] === label ? 'text-primary-1000 bg-gray-50' : '']"
      >
        <div class="w-full px-8 py-4 text-center">{{ label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// Examples for Props

// selectedClass: {
//         _pp: "Part",
//       },

//  possibleClasses:{
//         _pp: "Part",
//         _pl: "Lot",
//         _pj: "Job",
//       };

export default {
  name: 'Toggle',

  props: {
    possibleClasses: Object,
    selectedClass: Object,
  },

  emits: ['selected'],

  methods: {
    icChecked(key, label) {
      return this.selectedClass[key] == label;
    },

    changeClass(key, label) {
      this.$emit('selected', { [key]: label });
    },
  },
};
</script>
